import React, { Component } from 'react';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { Content } from '../../../infrastructure/content';
import AboutYourBusinessAccordionItem from '../../businessDetailsAll/components/AboutYourBusinessAccordionItem';
import TaxFinancesAccordionItem from '../../businessDetailsAll/components/TaxFinancesAccordionItem';
import ContactDetailsAccordionItem from '../../businessDetailsAll/components/ContactDetailsAccordionItem';
import BusinessFinancesAccordionItem from '../../businessDetailsAll/components/BusinessFinancesAccordionItem';
import AcceptError from './AcceptError';
import SaveAndContinue from '../../../components/SaveAndContinue';
import {
  ABOUT_BUSINESS_PAGE_KEY,
  BUSINESS_DETAILS_PAGE_KEY,
  TAX_FINANCE_PAGE_KEY,
  BUSINESS_FINANCE_PAGE_KEY
} from '../../routUtils/routingConstants';
import { isAccordianNeeded } from '../../routUtils/routingUtils';
import { getQueryStringValueByName } from '../../../utils';
import { SHOW_PAGE_TYPE, EXPAND_KEY } from '../../../utils/constants';

class BusinessDetailsAllPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nonEdit: 0,
      updateEditClick: false,
      aboutBusinessCollapsed: true,
      businessFinanceCollapsed: true,
      taxFinanceCollapsed: true,
      contactDetailsCollapsed: true,
      isFormEdited: false
    };
    this.editClick = this.editClick.bind(this);
    this.updateAccordionForm = this.updateAccordionForm.bind(this);
    this.aboutBusinessClicked = this.aboutBusinessClicked.bind(this);
    this.businessFinanceClicked = this.businessFinanceClicked.bind(this);
    this.taxFinanceClicked = this.taxFinanceClicked.bind(this);
    this.contactDetailsClicked = this.contactDetailsClicked.bind(this);
    this.onValueChanges = this.onValueChanges.bind(this);
    this.resetStateOfnonEdit = this.resetStateOfnonEdit.bind(this);
    this.processUpdateAccordian = this.processUpdateAccordian.bind(this);
  }

  componentDidMount() {
    expandAccordian();
  }
  editClick(isEdit) {
    this.setState({ isFormEdited: false });
    this.setState({ nonEdit: isEdit ? this.state.nonEdit + 1 : this.state.nonEdit - 1 });
    if (this.state.nonEdit === 0) {
      this.setState({ updateEditClick: false });
    }
  }

  updateAccordionForm() {
    if (this.state.nonEdit > 0) {
      this.setState({ updateEditClick: true });
    } else if (!this.state.isFormEdited || this.state.nonEdit === 0) {
      this.processUpdateAccordian();
    }
  }

  processUpdateAccordian() {
    if (!this.state.isFormEdited) {
      this.props.redirectToBusinessAccount();
    } else if (this.state.nonEdit === 0) {
      this.props.updateAccordionForm(this.props.businessId);
    }
  }

  aboutBusinessClicked() {
    !this.state.aboutBusinessCollapsed
      ? this.setState({ aboutBusinessCollapsed: true })
      : this.setState({ aboutBusinessCollapsed: false });
    this.resetStateOfnonEdit();
  }
  businessFinanceClicked() {
    !this.state.businessFinanceCollapsed
      ? this.setState({ businessFinanceCollapsed: true })
      : this.setState({ businessFinanceCollapsed: false });
    this.resetStateOfnonEdit();
  }
  taxFinanceClicked() {
    !this.state.taxFinanceCollapsed
      ? this.setState({ taxFinanceCollapsed: true })
      : this.setState({ taxFinanceCollapsed: false });
    this.resetStateOfnonEdit();
  }
  contactDetailsClicked() {
    !this.state.contactDetailsCollapsed
      ? this.setState({ contactDetailsCollapsed: true })
      : this.setState({ contactDetailsCollapsed: false });
    this.resetStateOfnonEdit();
  }

  resetStateOfnonEdit() {
    if (isAllAccordianCollapsed(this.state)) {
      this.setState({ nonEdit: 0 });
      this.setState({ updateEditClick: false });
    }
  }

  onValueChanges(value) {
    this.setState({ isFormEdited: value });
  }

  render() {
    const {
      getBusinessData,
      isSoleBusinessType,
      saveContactChanges,
      saveTaxFinanceChanges,
      saveBusinessFinanceChanges,
      saveAboutBusinessChanges,
      findAddress,
      lookUpRegisterDetails,
      lookUpTradingDetails,
      lookUpMailingDetails,
      showRegisterChoosenAddress,
      showRegisterPostCode,
      showMailingChoosenAddress,
      showMailingPostCode,
      showTradingChoosenAddress,
      showTradingPostCode,
      onClickAddress,
      onAddManuallyClick,
      isRegisterAddManuallyClicked,
      isTradingAddManuallyClicked,
      isMailingAddManuallyClicked,
      getCustomerData,
      address,
      onSelectAddressClick,
      registeredAddressId,
      tradingAddressId,
      mailingAddressId,
      registerAddressSelect,
      tradingAddressSelect,
      businessId,
      isTradingUkResident,
      isMailingUKResident,
      isTradingInternationalResident,
      isMailingInternationalResident,
      registerAddressValue,
      tradingAddressValue,
      mailingAddressValue,
      saveAboutYourFormValues,
      editButtonClicks,
      onAddressEditClick,
      onAddressSelection,
      linkCode,
      onCancelEditClick,
      customerData
    } = this.props;
    return (
      <div>
        <Content>
          {({
            reviewBusinessDetails = '',
            businessHeader = '',
            businessFinance = '',
            financeHeader = '',
            contactDetails = ''
          }) => (
            <div>
              <PageHeading>{reviewBusinessDetails}</PageHeading>

              {isAccordianNeeded(ABOUT_BUSINESS_PAGE_KEY) ? (
                <div>
                  <SectionHeading>{businessHeader}</SectionHeading>

                  <AboutYourBusinessAccordionItem
                    getBusinessData={getBusinessData}
                    isSoleBusinessType={isSoleBusinessType}
                    saveAboutBusinessChanges={saveAboutBusinessChanges}
                    onCancelEditClick={onCancelEditClick}
                    findAddress={findAddress}
                    lookUpRegisterDetails={lookUpRegisterDetails}
                    lookUpTradingDetails={lookUpTradingDetails}
                    lookUpMailingDetails={lookUpMailingDetails}
                    onClickAddress={onClickAddress}
                    showRegisterChoosenAddress={showRegisterChoosenAddress}
                    showRegisterPostCode={showRegisterPostCode}
                    showTradingChoosenAddress={showTradingChoosenAddress}
                    showTradingPostCode={showTradingPostCode}
                    showMailingChoosenAddress={showMailingChoosenAddress}
                    showMailingPostCode={showMailingPostCode}
                    onAddManuallyClick={onAddManuallyClick}
                    isRegisterAddManuallyClicked={isRegisterAddManuallyClicked}
                    isTradingAddManuallyClicked={isTradingAddManuallyClicked}
                    isMailingAddManuallyClicked={isMailingAddManuallyClicked}
                    getCustomerData={getCustomerData}
                    editClick={this.editClick}
                    onSelectAddressClick={onSelectAddressClick}
                    address={address}
                    registeredAddressId={registeredAddressId}
                    tradingAddressId={tradingAddressId}
                    mailingAddressId={mailingAddressId}
                    registerAddressSelect={registerAddressSelect}
                    tradingAddressSelect={tradingAddressSelect}
                    businessId={businessId}
                    isTradingUkResident={isTradingUkResident}
                    isMailingUKResident={isMailingUKResident}
                    isTradingInternationalResident={isTradingInternationalResident}
                    isMailingInternationalResident={isMailingInternationalResident}
                    onValueChanges={this.onValueChanges}
                    linkCode={linkCode}
                    registerAddressValue={registerAddressValue}
                    tradingAddressValue={tradingAddressValue}
                    mailingAddressValue={mailingAddressValue}
                    saveAboutYourFormValues={saveAboutYourFormValues}
                    editButtonClicks={editButtonClicks}
                    onAddressEditClick={onAddressEditClick}
                    onAddressSelection={onAddressSelection}
                  />
                </div>
              ) : (
                <span />
              )}
              {isAccordianNeeded(BUSINESS_FINANCE_PAGE_KEY) ? (
                <div>
                  <SectionHeading>{businessFinance}</SectionHeading>

                  <BusinessFinancesAccordionItem
                    getBusinessData={getBusinessData}
                    onCancelEditClick={onCancelEditClick}
                    onValueChanges={this.onValueChanges}
                    saveBusinessFinanceChanges={saveBusinessFinanceChanges}
                    linkCode={linkCode}
                    editClick={this.editClick}
                  />
                </div>
              ) : (
                <span />
              )}
              {isAccordianNeeded(TAX_FINANCE_PAGE_KEY) ? (
                <div>
                  <SectionHeading>{financeHeader}</SectionHeading>

                  <TaxFinancesAccordionItem
                    getBusinessData={getBusinessData}
                    onCancelEditClick={onCancelEditClick}
                    onValueChanges={this.onValueChanges}
                    saveTaxFinanceChanges={saveTaxFinanceChanges}
                    linkCode={linkCode}
                    editClick={this.editClick}
                  />
                </div>
              ) : (
                <span />
              )}
              {isAccordianNeeded(BUSINESS_DETAILS_PAGE_KEY) ? (
                <div>
                  <SectionHeading>{contactDetails}</SectionHeading>

                  <ContactDetailsAccordionItem
                    onValueChanges={this.onValueChanges}
                    getBusinessData={getBusinessData}
                    saveContactChanges={saveContactChanges}
                    onCancelEditClick={onCancelEditClick}
                    editClick={this.editClick}
                    linkCode={linkCode}
                  />
                </div>
              ) : (
                <span />
              )}
            </div>
          )}
        </Content>
        <div className="u-margin-top-3">
          {customerData && (
            <AcceptError
              nonEdit={this.state.nonEdit === 0}
              editClickError={this.state.updateEditClick}
            />
          )}
        </div>
        <SaveAndContinue onClick={this.updateAccordionForm} />
      </div>
    );
  }
}

const expandAccordian = () => {
  const accordian = document.getElementsByClassName('c-m-accordion__control');
  const pagesToExpand = getQueryStringValueByName(EXPAND_KEY);
  const pages = getQueryStringValueByName(SHOW_PAGE_TYPE);
  if (pagesToExpand && pagesToExpand.length > 0 && pages && pages.length > 0) {
    pagesToExpand.split(',').forEach((value) => {
      const expandIndex = pages.split(',').indexOf(value);
      if (expandIndex > -1) accordian[expandIndex].click();
    });
  }
};

const isAllAccordianCollapsed = (state) =>
  state.aboutBusinessCollapsed &&
  state.businessFinanceCollapsed &&
  state.taxFinanceCollapsed &&
  state.contactDetailsCollapsed;

export default BusinessDetailsAllPage;
